import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGetBusinessNumUidQuery } from '../../store/ReactWebSiteApi';
function GetOperator(props) {
    const [list,setList] = useState();
    const {data,isSuccess} = useGetBusinessNumUidQuery({ebn_e_id:localStorage.getItem('e_id')})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // console.log(data);
                const arr = data.Result.map((item) => {
                    const {ebn_uid,ebn_uname} = item
                    return {value:ebn_uid,label:ebn_uname}
                })
                setList(arr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        // console.log(f);
                        props.getOperator(f.value,f.label)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.placeholder}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default GetOperator